// src/components/common/EmailVerificationBadge.js
import React from 'react';

/**
 * EmailVerificationBadge Component
 * Displays email verification status with color-coded badges
 *
 * @param {string} emailVerifiedAt - Timestamp of email verification (null if not verified)
 * @param {string} timezone - Organization timezone for timestamp display
 */
const EmailVerificationBadge = ({ emailVerifiedAt, timezone = 'UTC' }) => {
    if (!emailVerifiedAt) {
        return (
            <span
                className="badge"
                style={{
                    backgroundColor: '#ffc107',
                    color: '#000',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontSize: '0.75rem',
                    fontWeight: '600',
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '4px'
                }}
                title="Email verification pending"
            >
                <svg
                    width="12"
                    height="12"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                >
                    <circle cx="12" cy="12" r="10"/>
                    <line x1="12" y1="8" x2="12" y2="12"/>
                    <line x1="12" y1="16" x2="12.01" y2="16"/>
                </svg>
                Pending Verification
            </span>
        );
    }

    // Format verified timestamp
    const formatDate = (timestamp) => {
        try {
            const date = new Date(timestamp);
            return date.toLocaleDateString('en-US', {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
        } catch (error) {
            return timestamp;
        }
    };

    return (
        <span
            className="badge"
            style={{
                backgroundColor: '#28a745',
                color: '#fff',
                padding: '4px 8px',
                borderRadius: '4px',
                fontSize: '0.75rem',
                fontWeight: '600',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '4px'
            }}
            title={`Verified on ${formatDate(emailVerifiedAt)}`}
        >
            <svg
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
            >
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                <polyline points="22 4 12 14.01 9 11.01"/>
            </svg>
            Verified
        </span>
    );
};

export default EmailVerificationBadge;
